<form [formGroup]="editForm" (ngSubmit)="onSubmit()">
  <div class="flex items-end justify-between gap-3 mb-3">
    <app-page-hero [title]="'editDocumentType'"></app-page-hero>
    <button
      type="submit"
      class="shrink-0 px-3.5 h-9 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium"
    >
      {{ "save" | transloco }}
    </button>
  </div>

  <div>
    <div>
      <div class="text-[14px] font-medium !text-slate-700 mb-1">
        {{ "name" | transloco }}
      </div>
      <div [appValidateState]="editForm.get('name')">
        <input
          id="name"
          formControlName="name"
          type="text"
          class="w-full text-[14px] !text-slate-800 !bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
          placeholder="{{ 'name' | transloco }}"
          autocomplete="off"
          (keydown.enter)="$event.preventDefault()"
        />
      </div>
    </div>

    <div class="mt-3 flex items-center gap-2">
      <p-toggleswitch formControlName="isShownOnSideMenu" />
      <span class="text-[14px] font-medium !text-slate-700">
        {{ "showOnSidebar" | transloco }}
      </span>
    </div>
  </div>
</form>
